export default __webpack_public_path__ + "static/media/20c-2x.de61e275.png";